export default __webpack_public_path__ + "static/media/ccec_logo.35a2560f.webp";